import type { FeedItem, TopicItem, FaqItem, TestimonialItem } from '@/types/feed';

export const siteInfo = {
  name: '夜半瓜社',
  slogan: '后半夜的瓜，有人替你盯着',
  desc: '午夜、凌晨、后半夜通宵在线，把正在发酵的娱乐话题按时间线整理清楚。睡不着的时候，来瓜田逛一圈。',
  email: 'nightwatch@yebanguashe.com',
  city: '线上内容编辑部',
  domain: 'https://qijingchun.cn',
};

export const categories = [
  '塌房现场',
  '反转连续剧',
  '恋情疑云',
  '业内爆料',
  '旧瓜新吃',
  '深夜快讯',
];

export const timeSlots = [
  { key: '午夜档', range: '00:00 - 03:00', desc: '刚过零点，第一波话题开始冒头' },
  { key: '凌晨档', range: '03:00 - 05:00', desc: '全网最安静，也是料最猛的时候' },
  { key: '后半夜', range: '05:00 - 06:30', desc: '天亮之前的最后一段发酵期' },
  { key: '通宵场', range: '全天滚动', desc: '通宵值夜的编辑随时补更' },
  { key: '失眠特供', range: '随机掉落', desc: '专门写给翻来覆去睡不着的人' },
];

export const feedItems: FeedItem[] = [
  {
    slug: 'midnight-collapse-trending',
    title: '凌晨两点话题突然升温：某选秀出身的顶流被指与旧团队彻底切割',
    summary:
      '零点后相关词条仍在低位徘徊，两点前后讨论量突然翻了三倍。多个账号同时放出合照与聊天截图，时间线却对不上，事情正在往奇怪的方向走。',
    category: '塌房现场',
    timeSlot: '凌晨档',
    stage: '持续发酵',
    heat: 9820,
    publishedAt: '今天 02:14',
    readMinutes: 5,
    author: '值夜编辑 · 阿灯',
    image:
      'https://readdy.ai/api/search-image?query=dark%20moody%20empty%20recording%20studio%20at%20night%20with%20a%20single%20warm%20amber%20spotlight%20and%20deep%20shadows%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=800&height=520&seq=nightgossip-f01&orientation=landscape',
    content: [
      '这件事最早的信号出现在凌晨一点四十左右。一个粉丝量并不算大的账号发出了一张早期合影，配文只有一句话，没有点名，也没有任何情绪词。截图在半小时内被搬运到几个讨论度较高的社区，然后开始有人把零散的信息拼在一起。',
      '真正让话题升起来的是两点零九分前后。三个互不关联的账号几乎同时发布内容，一份据称是工作群聊天记录，一份是行程单截图，还有一份是两年前的合约复印件。问题在于，这三份材料的日期口径互相打架，聊天记录里的时间戳甚至比合约签署日期还早。',
      '目前圈内比较克制的看法是：有矛盾大概率是真的，但"彻底切割"这个说法下得太早。熟悉这类流程的人都知道，团队更替往往有一到两个月的过渡缓冲期，公开场合不互动，并不等于私下已经撕破脸。',
      '接下来值得盯的节点有两个。一是相关方是否会在白天工作时间内给出正面说明，二是那份行程单能否被第三方验证。如果到上午十点仍然没有回应，按照过往节奏，话题热度大概率会在午间回落，然后等到今晚再次被提起。',
      '我们不对任何具体个人做定性判断，也不建议把截图当作结论。晚上睡不着的时候可以看，但别把情绪押上去。',
    ],
    timeline: [
      { time: '01:42', text: '小号发布早期合影，未点名，评论区开始猜测' },
      { time: '02:09', text: '三份材料几乎同时出现，讨论量短时间翻三倍' },
      { time: '02:31', text: '有账号指出聊天记录时间戳与合约日期对不上' },
      { time: '03:05', text: '话题进入平台榜单前二十，讨论开始分化' },
    ],
  },
  {
    slug: 'reversal-drama-three-acts',
    title: '反转连续剧更新第三集：昨天还言之凿凿的爆料，今天被当事人行程反打',
    summary:
      '同一个话题二十四小时内拐了三个弯。先是聊天记录，再是监控截图，最后是航班行程。每一次反转，都把前一次的"实锤"变成了猜谜，围观群众已经不知道该信哪一版。',
    category: '反转连续剧',
    timeSlot: '午夜档',
    stage: '出现反转',
    heat: 8740,
    publishedAt: '今天 00:47',
    readMinutes: 6,
    author: '值夜编辑 · 阿灯',
    image:
      'https://readdy.ai/api/search-image?query=dim%20theatre%20stage%20with%20deep%20red%20curtains%20and%20a%20single%20warm%20spotlight%20in%20an%20empty%20dark%20hall%2C%20moody%20cinematic%20photography%2C%20rich%20shadows&width=800&height=520&seq=nightgossip-f02&orientation=landscape',
    content: [
      '这类话题最怕的不是没料，而是料太多。二十四小时之内，同一个词条下面出现了三个版本，每个版本都有看起来很像证据的东西，但彼此之间无法共存。',
      '第一版的说法在昨天下午出现，核心是一段聊天记录。第二版在晚上补上，是一张监控截图。到了今天凌晨，第三版出现，抛出的是一份公开可查的航班行程。问题来了：行程显示当事人在争议时段并不在传闻中的城市。',
      '于是舆论分成了三派。一派认为前面两份材料是伪造的，一派认为行程可以代持或者改签，还有一派干脆表示这整件事就是一场提前设计好的话题运营。三派各自讲得头头是道，谁也无法说服谁。',
      '从内容整理的角度，我们更关心一个细节：三份材料的出现间隔非常规律，几乎每六到八小时一次，这个节奏不太像自然发酵，更像是有人在按时间投放。',
      '所以先别急着站队。反转连续剧最忌讳的就是看到第二集就下结论，通常第四集才是真正见分晓的地方。',
    ],
    timeline: [
      { time: '昨日 15:20', text: '第一版聊天记录出现，话题初次升温' },
      { time: '昨日 21:40', text: '监控截图补齐，讨论转向"实锤"叙事' },
      { time: '今日 00:12', text: '航班行程被翻出，指向当事人不在场' },
      { time: '今日 00:47', text: '三方观点分裂，话题热度维持高位' },
    ],
  },
  {
    slug: 'late-night-romance-rumor',
    title: '后半夜被拍到的同框：恋情疑云再起，双方工作室凌晨保持沉默',
    summary:
      '一组夜间同框照片在四点前后流传，拍摄时间、地点都能对上，但画面本身没有更多信息。真正的看点，是双方团队直到天亮都没有出手。',
    category: '恋情疑云',
    timeSlot: '后半夜',
    stage: '刚起头',
    heat: 7310,
    publishedAt: '今天 04:22',
    readMinutes: 4,
    author: '值夜编辑 · 小满',
    image:
      'https://readdy.ai/api/search-image?query=quiet%20rainy%20city%20street%20at%20four%20in%20the%20morning%20with%20warm%20streetlamp%20glow%20reflecting%20on%20wet%20asphalt%2C%20dark%20moody%20atmosphere%2C%20cinematic&width=800&height=520&seq=nightgossip-f03&orientation=landscape',
    content: [
      '四点左右流出的这组照片，质量不算高，但胜在信息完整：时间可查、地点可对、人物轮廓清楚。两人一前一后走出同一栋楼，间隔大约两分钟，全程没有并肩，也没有肢体接触。',
      '这样的画面严格来说证明不了什么。朋友聚会、工作碰面、同住一个小区的同事，都能拍出类似的照片。但有意思的是另一件事：按照这两家团队过往的反应速度，通常两小时内就会有人在评论区"引导"，这一次却安静得反常。',
      '沉默在娱乐圈有两种解读。一种是懒得理，因为确实没有的事；另一种是在等，等一个更合适的说明窗口。经验告诉我们，前者通常会在第二天上午随手发一句模糊回应，后者则会拖到有明显舆情压力时才动。',
      '所以这条现在只能挂个"观察中"。真正需要留意的是接下来二十四小时内的措辞变化，尤其是团队是否从"纯属朋友"升级到"保留法律追究"这类更强硬的版本。',
      '夜里看到这种消息，看看就好。照片拍不到的部分，往往才是故事真正的样子。',
    ],
    timeline: [
      { time: '04:05', text: '夜间同框照片开始在小范围流传' },
      { time: '04:22', text: '话题词条出现，讨论集中在拍摄地点' },
      { time: '05:30', text: '双方团队均未回应，网友称"沉默最可疑"' },
    ],
  },
  {
    slug: 'industry-insider-midnight',
    title: '深夜业内爆料：某项目临时换角，制作方凌晨连发三条变更通知',
    summary:
      '一个已经开机两周的项目在凌晨突然调整主演阵容。通知发出时间集中在三点到四点之间，措辞谨慎，但变更动作不小。',
    category: '业内爆料',
    timeSlot: '通宵场',
    stage: '持续发酵',
    heat: 6480,
    publishedAt: '今天 03:36',
    readMinutes: 5,
    author: '值夜编辑 · 老周',
    image:
      'https://readdy.ai/api/search-image?query=abandoned%20film%20set%20at%20night%20with%20warm%20work%20lamps%20and%20camera%20equipment%20under%20deep%20shadows%2C%20moody%20cinematic%20industrial%20photography&width=800&height=520&seq=nightgossip-f04&orientation=landscape',
    content: [
      '三条变更通知的发出时间分别是三点十一分、三点三十八分和四点整，间隔很有规律。内容本身写得非常克制，只提到"因档期与创作方向调整"，没有说明具体原因。',
      '但在行业里，开机两周换角属于相当重的动作。前期拍摄素材、已排好的通告、甚至部分宣发物料都要跟着改。通常只有在两种情况下才会这么果断：一是艺人方出现了无法调和的档期冲突，二是资方对现有方向产生了明确分歧。',
      '目前流传的说法有好几个版本，都比较散。有说是因为另一部戏延期牵连，也有说是艺人身体原因，还有说单纯是剧本调整。这些说法目前都没有任何一方的确认。',
      '对我们来说，更值得记录的是这背后的行业节奏：深夜处理这类变动，说明制作端希望把消息控制在最小范围内，赶在第二天媒体工作时间之前完成内部沟通。',
      '这条信息我们只做整理，不做评价。行业里的变动，最终都会在作品里体现出来。',
    ],
    timeline: [
      { time: '03:11', text: '制作方发出第一条档期变更通知' },
      { time: '03:38', text: '第二条通知确认主演阵容调整' },
      { time: '04:00', text: '第三条通知同步宣发口径' },
      { time: '08:20', text: '行业媒体陆续跟进，说法不一' },
    ],
  },
  {
    slug: 'old-gossip-new-reading',
    title: '旧瓜新吃：三年前被嘲的那次造型，现在被翻出来当成了先见之明',
    summary:
      '一条三年前的旧动态在凌晨被大规模重提。当年的评论区几乎全是吐槽，如今的风向完全倒过来，网友开始逐帧分析当时的设计逻辑。',
    category: '旧瓜新吃',
    timeSlot: '失眠特供',
    stage: '缓慢升温',
    heat: 5230,
    publishedAt: '今天 01:58',
    readMinutes: 4,
    author: '值夜编辑 · 小满',
    image:
      'https://readdy.ai/api/search-image?query=antique%20wooden%20chest%20with%20old%20photo%20albums%20and%20warm%20lantern%20light%20in%20a%20dark%20room%2C%20nostalgic%20moody%20still%20life%20photography&width=800&height=520&seq=nightgossip-f05&orientation=landscape',
    content: [
      '互联网的有趣之处就在这儿：同一条内容，三年之后再看，评论区可以完全反过来。',
      '这次的导火索是一组旧照片被重新发出来。当年这条动态下面的高赞评论，清一色在说造型用力过猛、脱离了大众审美。而今天凌晨的新评论里，被顶到最前面的变成了"其实这个设计很超前"。',
      '为什么会这样？一部分原因是这几年大众审美确实变了，当年显得夸张的元素，如今在别的场景里已经很常见。另一部分原因更现实：当一个人红了之后，过往的一切都会被重新解读。',
      '我们翻了那条动态的时间线，发现重提的账号大多集中在凌晨一点到两点之间，发布时间相差不到二十分钟，这更像是一次有组织的重温，而不是自然翻旧账。',
      '旧瓜新吃本身没什么问题，图个乐子而已。只是别忘了，当年的评论和今天的评论，可能来自同一批人。',
    ],
    timeline: [
      { time: '01:12', text: '旧照片被重新发布，配文"回头看看"' },
      { time: '01:35', text: '多个账号集中搬运，评论区风向开始变化' },
      { time: '01:58', text: '"审美超前"成为新的高赞观点' },
    ],
  },
  {
    slug: 'midnight-flash-rumor-check',
    title: '深夜快讯核查：一条被传了六小时的消息，最后发现源头是营销号互抄',
    summary:
      '从晚上十点传到凌晨四点，内容越传越具体，细节却越来越对不上。顺着转发链往回找，最早的源头是一个只有几百粉丝的账号。',
    category: '深夜快讯',
    timeSlot: '通宵场',
    stage: '热度回落',
    heat: 4120,
    publishedAt: '今天 04:50',
    readMinutes: 6,
    author: '值夜编辑 · 老周',
    image:
      'https://readdy.ai/api/search-image?query=night%20city%20neon%20signs%20partially%20blurred%20with%20warm%20orange%20and%20red%20glow%20on%20dark%20street%2C%20abstract%20urban%20cinematic%20photography&width=800&height=520&seq=nightgossip-f06&orientation=landscape',
    content: [
      '现在回头看，这条消息的传播路径非常典型。晚上十点左右，一个小号发了一句模糊的话，没有主语，没有细节，只是暗示"某位艺人最近会有大动作"。',
      '到了午夜，第一个营销号开始加细节，把"某位艺人"具体成了三个可能的范围。凌晨一点，第二个账号把范围缩到一个人。到了三点，已经有人给出所谓的"时间表"和"处理方案"了。',
      '有意思的是，越往后内容越具体，但没有任何一份新增材料。所有人都在转述同一句话，只是转述得越来越笃定。',
      '我们顺着转发链往回找了七层，最早那条原始内容只有几十个赞。也就是说，一条没有信息量的模糊发言，在六个小时内被加工成了一个看起来板上钉钉的"内部消息"。',
      '所以深夜看到越具体、越笃定的爆料，越要多问一句：原始材料在哪？如果找不到，那它多半只是转述，不是消息。',
    ],
    timeline: [
      { time: '22:10', text: '小号发布模糊发言，无主语无细节' },
      { time: '00:30', text: '第一个营销号补充细节，扩大传播' },
      { time: '01:40', text: '范围被缩到具体个人，讨论量上升' },
      { time: '03:00', text: '出现"时间表"版本，无新材料支撑' },
      { time: '04:50', text: '溯源完成，源头为低粉账号，热度回落' },
    ],
  },
  {
    slug: 'trouble-warning-signals',
    title: '塌方预警：这些细小的信号，往往比爆料本身更早出现',
    summary:
      '真正值得留意的通常不是那篇长文，而是长文出现前几周的小动作：删动态、改简介、换头像、突然清空关注列表。',
    category: '塌房现场',
    timeSlot: '凌晨档',
    stage: '观察中',
    heat: 3890,
    publishedAt: '今天 03:58',
    readMinutes: 5,
    author: '值夜编辑 · 阿灯',
    image:
      'https://readdy.ai/api/search-image?query=warning%20lights%20glowing%20amber%20on%20a%20dark%20industrial%20wall%20at%20night%20with%20fog%2C%20moody%20high%20contrast%20cinematic%20photography&width=800&height=520&seq=nightgossip-f07&orientation=landscape',
    content: [
      '做了几年内容整理，我们慢慢总结出一个规律：真正的大新闻很少毫无预兆。在长文出现之前，当事人或其团队往往会有一连串不太起眼的小动作。',
      '最常见的三种。第一是社交账号的静默期突然变长，原本高频互动的人开始只发工作内容。第二是简介、头像、关注列表这类边缘信息的调整，而且调整得很随意，像是随手清理。第三是行程的异常留白，原本排满的档期忽然空出一整周。',
      '单独看任何一种都不说明问题，忙起来、想休息、换团队，都会出现类似情况。但如果三件事同时发生，且集中在两周之内，就值得多留意一下了。',
      '需要提醒的是，这套观察方法只适合用来理解节奏，不能用来给任何人定罪。人的状态本来就起起伏伏，把正常调整解读成"出事了"，是最容易闹笑话的。',
      '所以看到预警类内容，先别转发。等一等，看看有没有后续。',
    ],
    timeline: [
      { time: '两周前', text: '相关账号互动频率明显下降' },
      { time: '一周前', text: '简介与关注列表出现小范围调整' },
      { time: '03:58', text: '相关讨论在深夜社区升温，尚无实质材料' },
    ],
  },
  {
    slug: 'after-midnight-fan-night',
    title: '午夜档观察：为什么所有大瓜，都喜欢在夜里落地？',
    summary:
      '统计了近一年的话题发布时间，凌晨零点到四点确实是绝对高峰。这背后有平台机制，也有人的生理节律，还有一点传播上的小算盘。',
    category: '深夜快讯',
    timeSlot: '午夜档',
    stage: '持续发酵',
    heat: 3560,
    publishedAt: '昨天 23:58',
    readMinutes: 5,
    author: '值夜编辑 · 小满',
    image:
      'https://readdy.ai/api/search-image?query=analog%20clock%20on%20a%20dark%20table%20lit%20by%20warm%20desk%20lamp%20at%20midnight%20with%20long%20shadows%2C%20moody%20minimal%20still%20life%20photography&width=800&height=520&seq=nightgossip-f08&orientation=landscape',
    content: [
      '我们把近一年的话题首发时间做了一次粗略统计，结果并不意外：零点到四点之间的占比接近四成，远高于其他时段。',
      '原因至少有四层。第一层是平台机制，深夜自然流量竞争小，同样的内容更容易拿到推荐位。第二层是人群结构，这个时间段活跃的用户更愿意参与讨论，也更容易情绪化，互动率天然更高。',
      '第三层是人的生理节律。凌晨决策能力和判断力都会下降，对信息的怀疑阈值变低，看到一段聊天记录就相信的概率会明显上升。第四层则更直接：夜里发的东西，第二天早上还有整整半天时间可以被发酵、被讨论、被二次创作。',
      '把这四层叠起来看，深夜成为话题落地的黄金档就不难理解了。对内容整理者来说，这意味着凌晨的工作量最大；对普通读者来说，这意味着凌晨看到的东西，最好等天亮再看一遍。',
      '白天重新审一遍，很多凌晨觉得很震撼的内容，会突然显得平平无奇。这不是错觉，只是你的理智回来了。',
    ],
    timeline: [
      { time: '昨日 22:00', text: '发布时段统计数据，话题开始讨论' },
      { time: '昨日 23:58', text: '内容进入推荐池，午夜档流量明显上升' },
    ],
  },
  {
    slug: 'early-morning-silence',
    title: '天亮之前那半小时：话题最安静，但也最容易出现关键补充',
    summary:
      '五点之后流量骤降，大部分账号停更，可偏偏就是这个时段，经常会出现决定性的第三方材料。',
    category: '反转连续剧',
    timeSlot: '后半夜',
    stage: '出现反转',
    heat: 2980,
    publishedAt: '今天 05:12',
    readMinutes: 4,
    author: '值夜编辑 · 老周',
    image:
      'https://readdy.ai/api/search-image?query=soft%20orange%20dawn%20light%20over%20a%20quiet%20city%20skyline%20with%20warm%20window%20lights%20still%20on%20in%20dark%20buildings%2C%20minimal%20moody%20cinematic%20photography&width=800&height=520&seq=nightgossip-f09&orientation=landscape&nocache=true',
    content: [
      '如果你长期盯夜里的舆情，会发现一个现象：早上五点以后是参与度最低的时段，但恰恰在这段时间里，关键的补充材料出现得特别频繁。',
      '原因其实不复杂。这个时间点还在线的，要么是真正的当事人团队，要么是长期关注、手里确实有材料的观察者。营销号基本都睡了，噪音最少。',
      '所以我们把"后半夜"单独列成了一个栏目。它不是流量最高的时段，但常常是信息密度最高的时段：一份第三方记录、一段完整的原始对话、一个能验证时间线的公开信息，都可能在这个时候落地。',
      '当然，安静也意味着缺少交叉验证。凌晨五点发出来的东西，往往要等到上午九点以后才开始被核对，这中间有几个小时的空窗期，足够让一条错误信息跑得比真相还远。',
      '所以这个时段的内容，我们都会标注"待核"。看完先放一放，醒来再说。',
    ],
    timeline: [
      { time: '05:04', text: '某第三方记录在低流量时段被放出' },
      { time: '05:12', text: '内容进入整理流程，标注为待核信息' },
      { time: '09:30', text: '白天开始出现交叉验证，结论待定' },
    ],
  },
  {
    slug: 'insomnia-only-reading',
    title: '失眠特供：如果你已经翻了两个小时还没睡着，不如看点轻松的',
    summary:
      '不是每个深夜都需要跟进最热的那条话题，有时候一段轻松的旧闻回顾，反而更适合凌晨三点的大脑。',
    category: '旧瓜新吃',
    timeSlot: '失眠特供',
    stage: '缓慢升温',
    heat: 2140,
    publishedAt: '今天 02:40',
    readMinutes: 3,
    author: '值夜编辑 · 小满',
    image:
      'https://readdy.ai/api/search-image?query=warm%20tea%20cup%20and%20open%20book%20on%20a%20dark%20wooden%20desk%20under%20soft%20amber%20lamp%20light%20at%20night%2C%20cozy%20moody%20still%20life%20photography&width=800&height=520&seq=nightgossip-f10&orientation=landscape',
    content: [
      '凌晨两点四十还在刷手机的人，通常不是不想睡，而是脑子停不下来。这个时候去看最激烈的那条话题，只会让你更清醒。',
      '所以我们把"失眠特供"单独做成了一类内容。它不追热点，不更新最猛的材料，只挑一些节奏平缓、读起来不费劲的旧闻回顾。',
      '这类内容的特点是：没有反转，没有站队，也不会让你产生"我必须马上知道后续"的焦虑。读完放下手机，情绪是平的。',
      '如果你今晚正好睡不着，建议从这一栏进去随便点一篇。看完就关掉屏幕，别再点下一个。',
      '瓜田一直在，明天醒着的时候再来也不迟。',
    ],
    timeline: [
      { time: '02:20', text: '失眠特供栏目补更一篇轻松回顾' },
      { time: '02:40', text: '内容被夜间用户自发分享到几个失眠话题' },
    ],
  },
];

export const hotRank = [
  { slug: 'midnight-collapse-trending', title: '某选秀顶流被指与旧团队切割', heat: 9820, tag: '爆' },
  { slug: 'reversal-drama-three-acts', title: '反转连续剧更新第三集', heat: 8740, tag: '热' },
  { slug: 'late-night-romance-rumor', title: '后半夜同框照流出', heat: 7310, tag: '热' },
  { slug: 'industry-insider-midnight', title: '项目凌晨临时换角', heat: 6480, tag: '新' },
  { slug: 'old-gossip-new-reading', title: '三年前造型被翻出重评', heat: 5230, tag: '新' },
  { slug: 'midnight-flash-rumor-check', title: '传了六小时的消息溯源', heat: 4120, tag: '查' },
];

export const topics: TopicItem[] = [
  {
    title: '午夜档 · 零点之后的第一波',
    desc: '零点到三点之间的新鲜话题，通常还在雏形阶段，材料零散但方向值得留意。',
    count: '收录 128 条',
    image:
      'https://readdy.ai/api/search-image?query=empty%20rainy%20alley%20at%20midnight%20with%20single%20warm%20streetlight%20and%20deep%20shadows%2C%20forlorn%20cinematic%20mood%20photography&width=900&height=620&seq=nightgossip-t01&orientation=landscape',
    href: '/feed?slot=%E5%8D%88%E5%A4%9C%E6%A1%A3',
  },
  {
    title: '凌晨档 · 全网最安静的几小时',
    desc: '三点到五点，营销号基本停更，反而更容易出现信息密度高的原始材料。',
    count: '收录 96 条',
    image:
      'https://readdy.ai/api/search-image?query=dark%20empty%20office%20corridor%20at%20three%20am%20lit%20by%20warm%20amber%20wall%20lamps%2C%20quiet%20cinematic%20atmosphere%2C%20long%20shadows&width=900&height=620&seq=nightgossip-t02&orientation=landscape',
    href: '/feed?slot=%E5%87%8C%E6%99%A8%E6%A1%A3',
  },
  {
    title: '后半夜 · 天亮前的补充期',
    desc: '五点之后流量骤降，但关键的第三方材料常常在这个时段落地。',
    count: '收录 74 条',
    image:
      'https://readdy.ai/api/search-image?query=dawn%20light%20breaking%20over%20sleeping%20city%20rooftops%20with%20warm%20orange%20sky%20gradient%20and%20dark%20buildings%2C%20cinematic%20minimal%20photography&width=900&height=620&seq=nightgossip-t03&orientation=landscape',
    href: '/feed?slot=%E5%90%8E%E5%8D%8A%E5%A4%9C',
  },
  {
    title: '通宵场 · 编辑随时补更',
    desc: '整夜滚动更新，覆盖午夜到清晨的所有动向，适合一觉醒来一次看全。',
    count: '收录 210 条',
    image:
      'https://readdy.ai/api/search-image?query=night%20city%20view%20through%20a%20rain%20covered%20window%20with%20warm%20amber%20lights%20blurred%20in%20the%20distance%2C%20moody%20cinematic%20photography&width=900&height=620&seq=nightgossip-t04&orientation=landscape',
    href: '/feed?slot=%E9%80%9A%E5%AE%B5%E5%9C%BA',
  },
];

export const homeFaqs: FaqItem[] = [
  {
    q: '这里的"深夜黑料"具体指什么内容？',
    a: '我们把深夜时段正在发酵的娱乐话题整理成条目，包括话题起点、材料出现顺序、反转节点和当前热度。所有内容均做了去标识化处理，只保留话题脉络，不指向任何具体真实个人。',
  },
  {
    q: '为什么要按午夜、凌晨、后半夜划分栏目？',
    a: '因为不同时段的传播环境差别很大。午夜流量竞争小、情绪化明显；凌晨噪音最少但材料密度高；后半夜参与度低，却常常出现关键的补充信息。分开整理，更便于理解话题的推进节奏。',
  },
  {
    q: '热度和"爆、热、新、查"这些标记是怎么来的？',
    a: '热度是根据词条讨论量、互动增速和跨平台扩散程度综合估出的一个相对值，用于横向比较，不代表任何事实判定。"爆"表示短时间讨论激增，"热"表示持续高位，"新"表示刚起头，"查"表示正在核查溯源。',
  },
];

export const aboutFaqs: FaqItem[] = [
  {
    q: '看到的内容会和第二天早上不一样吗？',
    a: '会。深夜发布的信息往往缺少交叉验证，我们会在白天重新核对并补充更新。部分条目会标注"待核"，表示结论尚未确定，建议醒来后再看一遍。',
  },
  {
    q: '可以投稿或者提供线索吗？',
    a: '可以。你可以通过订阅表单留下联系方式并简要说明线索方向，值夜编辑会在核对后决定是否整理成条目。我们更看重可验证的公开信息，而不是单方面的描述。',
  },
  {
    q: '为什么建议凌晨看到的内容不要马上转发？',
    a: '凌晨时人的判断阈值较低，同一段材料在夜里看起来比白天更有说服力。先放一放，等天亮信息补充完整后再判断，能避免很多误伤。',
  },
  {
    q: '发现某条整理有误，应该怎么处理？',
    a: '直接发邮件说明即可，附带可公开验证的来源链接或截图说明。我们会在核对后更正条目，并把更正记录同步到同一条内容里，不做静默删除。',
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: '小北',
    role: '常年凌晨两点睡',
    text: '别的号半夜只会发一句"有大事"，这里至少会告诉你几点几分出现了什么，为什么值得看。',
  },
  {
    name: '饼干不加冰',
    role: '通宵值班党',
    text: '后半夜栏目是真的有用。我上班的时候刷不到，一早起来直接看通宵场整理好的版本，省事。',
  },
  {
    name: '沉默的鱼',
    role: '失眠研究所',
    text: '最喜欢它不催你站队。看完不知道结论，但知道事情到哪一步了，这种感觉挺难得的。',
  },
  {
    name: '阿橙',
    role: '话题观察者',
    text: '热度标记和"待核"标签很实在，不会把猜测包装成实锤，这点比大多数同类型号都强。',
  },
];

export const contentPrinciples = [
  { title: '只整理进程，不定性结论', desc: '记录话题从什么时候开始、出现了哪些材料、在哪里发生反转，而不是给任何人下判断。' },
  { title: '去标识化处理', desc: '所有条目在整理时都会模糊具体身份信息，只保留话题本身的脉络与节奏。' },
  { title: '标注可信程度', desc: '缺少交叉验证的内容会明确标注"待核"，避免读者把转述当成原始材料。' },
  { title: '深夜不催转会', desc: '我们不鼓励在凌晨情绪最高的时候做转发决定，建议醒来后再判断。' },
];